module.exports = __webpack_public_path__ + "static/media/FD8.b3e3b8a3.png";